import dateFormat from 'dateformat'
import moment from 'moment'

const ONE_DAY_IN_MILLISECONDS = 1000 * 60 * 60 * 24
const DEFAULT_DATE_FORMAT = 'dd/mm/yyyy'
export const MONTHS = [
  'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
  'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
]

export const scheduleCalendarNavigation = (operation, view, calendarYear, calendarMonth, navigationCallback, context) => {
  const range = {
    months: {
      add: 1,
      subtract: -1
    }
  }
  const updateCalendarOperation = range[view][operation]
  const date = moment([calendarYear, calendarMonth - 1])
  const newDate = date.clone().add(updateCalendarOperation, view)

  navigationCallback(newDate, context)
}

export const mapMonthByDate = (date) => Array.from({ length: moment(date).endOf('month').date() }, (_, index) => moment(date).startOf('month').add(index, 'days').toDate())

export const formatDate = (date) => {
  return dateFormat(date, DEFAULT_DATE_FORMAT, true)
}

export const getCookieExpirationDate = (date) => {
  if (!date) {
    date = new Date()
    date.setTime(date.getTime() + ONE_DAY_IN_MILLISECONDS)
  }
  date = date instanceof Date ? date : new Date(date)
  return date.toUTCString()
}

export const isValidBirthDate = date => {
  if (!date) {
    return false
  }
  const momentDate = moment(date, 'DD/MM/YYYY', true)
  if (!momentDate.isValid()) {
    return false
  }
  if (momentDate.isAfter(new Date())) {
    return false
  }
  if (momentDate.isBefore(moment([1910]))) {
    return false
  }
  return true
}

export const getDate = (date) => {
  const localizedDate = moment(date).locale('pt-BR')
  return localizedDate.format('DD/MM/YY')
}
export const getTime = (date) => {
  const localizedDate = moment(date).locale('pt-BR')
  return localizedDate.format('HH:mm')
}
